import React from 'react';
import mapValues from 'lodash/mapValues';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import LangTabs from '../layout/LangTabs.jsx';

import env from '~/commons/config/env';

const defaults = {
  active: false,
  order: '0',

  title: mapValues(env.langs, () => ''),
  content: mapValues(env.langs, () => ''),
  coverImg: mapValues(env.langs, () => ''),
};

const FormNewFeature = ({
  newFeature,
}) => (
  <FormResource
    {...{
      defaults,
      stored: newFeature,
      api: '/api/site/new-features',
    }}
  >
    <FormGroup name="order" />

    <LangTabs>
      {({ lang }) => (
        <div className="pt-3">
          <FormGroup name={`title.${lang}`} label="Title" />
          <FormGroup
            name={`coverImg.${lang}`}
            as="coverImg"
            label="Cover Image"
            api="/api/site/new-features/files"
          />
          <FormGroup
            name={`content.${lang}`}
            label="Content"
            as="summernote"
            fileUploadUrl="/api/site/new-features/files"
          />
        </div>
      )}
    </LangTabs>
  </FormResource>
);

export default FormNewFeature;
